




















































import {
  CLASSIFIED_VIEW_NS,
  ClassifiedViewState
} from '~/store/modules/shared/classifieds/view/state'
import CAvatar from '~/components/shared/configurable/image/avatar/CAvatar.vue'
import CDirectionsButton from '~/components/shared/configurable/map/CDirectionsButton.vue'
import MarketplaceSellerModalTrigger from '~/components/car/marketplace/seller/MarketplaceSellerModalTrigger.vue'
import { useNamespacedStore } from '~/compositions/store'
import { computed, defineComponent } from '@nuxtjs/composition-api'

export default defineComponent({
  components: {
    MarketplaceSellerModalTrigger,
    CDirectionsButton,
    CAvatar
  },
  props: {
    seller: {
      type: Object,
      required: true
    }
  },
  setup(props) {
    const {
      state: classifiedViewState,
      getters: classifiedViewGetters
    } = useNamespacedStore<ClassifiedViewState>(CLASSIFIED_VIEW_NS)

    const sellerIsAgent = computed(() => classifiedViewGetters('sellerIsAgent'))

    const marketplace = computed(() => classifiedViewState.marketplace)

    const sellerGeolocation = computed(() => {
      if (!props.seller.geolocation) {
        return null
      }

      const [lat, lon] = props.seller.geolocation

      return { lat, lon }
    })

    const directionsLink = computed(
      () =>
        sellerGeolocation.value &&
        `https://www.google.com/maps/dir/?api=1&destination=${sellerGeolocation.value.lat},${sellerGeolocation.value.lon}`
    )

    return {
      sellerIsAgent,
      sellerGeolocation,
      directionsLink,
      marketplace
    }
  }
})
